var map = {
	"./bet-tnc-cn.svg": 2370,
	"./fifa-tnc-cn.svg": 2371,
	"./leaderboard-tnc-cn.svg": 2372,
	"./lucky-tnc-cn.svg": 2373,
	"./term-condition-bm.svg": 2374,
	"./term-condition-cn.svg": 2375,
	"./term-condition-id.svg": 2376,
	"./term-condition.svg": 2377,
	"./term-content.png": 2378,
	"./term-footer.png": 2379
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95;